import styled from 'styled-components/macro'

export const Label = styled.label`
  display: ${props => props.display};
`

export const LabelExtra = styled(Label)`
  line-height: ${props => props.lh};
  color: ${props => props.color};
  font-size: ${props => props.fontSize};
  font-weight: ${props => props.bold ? '900' : '100'};
  text-align: ${props => props.align};
  padding: ${props => props.padding};
  flex: 1;
  cursor: ${props => (props.isLink && "pointer") || props.cursor};
`

export const PercentLabel = styled(LabelExtra)`
  position: absolute;
  /* width: 40px;
  height: 20px; */
  top: 15px;
  /* left: 15px; */
  text-align: center;
  font-size: ${props => props.theme.fontSize.text};
`

export const TermsLink = styled.a`
  color: ${props => props.theme.colors.orange};
  text-decoration: none;
  &:active,
  &:hover {
    color: ${props => props.theme.colors.darkOrange};
    text-decoration: underline;
  }
`

export const ErrorLabel = styled.label`
  font-size: ${props => props.theme.fontSize.small};
  color: red;
  margin-top: auto;
`

export const Notification = styled.div`
  max-width: calc(${props => props.theme.maxWidth} - ${props => props.theme.left} - ${props => props.theme.right});
  transition-timing-function: ease-in-out;
  transition: all .9s ease-in-out;
  opacity: ${props => props.isShown ? 1 : 0};
  position: fixed;
  top: 50px;
  left: ${props => props.theme.left};
  right: ${props => props.theme.right};
  padding: ${props => props.theme.padding};
  margin:  auto;
  z-index: 4;
  color: #fff;
  display: flex;
  align-items: center;
  line-height: 20px;
  opacity: .95;

  &.error {
    background-color: ${props => props.theme.colors.red};
    border-radius: ${props => props.theme.borderRadius};
  }
  &.success {
    background-color: ${props => props.theme.colors.green};
  }
`

export const Title = styled.h1`
  font-size: ${props => props.theme.fontSize.header};
  font-weight: bold;
  line-height: ${props => props.theme.lineHeight};
  margin: 8px 0;
  color: ${props => props.color};
  text-align: ${props => props.align};
`

export const Content = styled.section`
  font-size: ${props => props.theme.fontSize.text};
  font-weight: normal;
  line-height: ${props => props.theme.lineHeight};
  white-space: pre-line;
  color: ${props => props.color};
  overflow-y: ${props => props.overflow};
`

export const Colored = styled.span`
  color: ${props => props.color};
  z-index: 5;
`

export const Wrapper = styled.section`
  display: flex;
  flex-direction: column;
  background-color: #fff;
  position: ${props => props.positioned && "relative"};
  padding: ${props => props.noPad ? '0' : props.theme.padding};
  align-items: ${props => props.centered && 'center'};
`

export const Container = styled(Wrapper)`
  margin-top: ${props => props.theme.header.height};
  position: relative;
`

export const SizedWrapper = styled(Wrapper)`
  width: ${props => props.width};
  height: ${props => props.height};
  padding: 0;
`

export const WrapperBottomButton = styled(Wrapper)`
  position: fixed;
  bottom: 0px;
  right: 0px;
  left: 0px;
  max-width: ${props => props.theme.maxWidth};
  margin: auto;
`;

export const Small = styled.div`
  font-size: ${props => props.theme.fontSize.small};
`
